import store from "@/store";
import { clearStorage, smartStorage } from ".";
import { ADMIN_ROLE, ADMIN_TYPE } from "./const";

export const getLoggedInUserRole = () => smartStorage.getItem("role");

export const getAuthToken = () => smartStorage.getItem("authToken");

export const getLoggedInUserName = () => smartStorage.getItem("userName");

// mainly used for login via cpanel
export const getExternalAuthToken = () => smartStorage.getItem("auth");

export const getAccountId = () => smartStorage.getItem("accountId");

export const getDomainName = () =>
  store.getters["domain/domainName"] || smartStorage.getItem("domain");

export const getBundleId = () =>
  store.getters["bundle/bundleId"] || smartStorage.getItem("bundleId");

export const getPartnerId = () => store.getters["partnerId"] || smartStorage.getItem("partnerId");

export const getLoggedInUserType = () => smartStorage.getItem("adminType");

export const isAccountAdminUser = () => getLoggedInUserType() === ADMIN_TYPE.ACCOUNT;

export const isCustomerUser = () => getLoggedInUserType() === ADMIN_TYPE.CUSTOMER;

// `loginEmail` is only set on direct panel login; the JWT/iframe flow
// (storeLoginData) populates `altEmail`/`tempUserAltEmail` instead — all
// three hold the same user's email. Fall back so this returns the current
// user even in the iframe Control Panel.
export const getCurrentUserEmail = () =>
  smartStorage.getItem("loginEmail") ||
  smartStorage.getItem("altEmail") ||
  smartStorage.getItem("tempUserAltEmail") ||
  "";

export const isLoginViaPartnerPanel = () => {
  const role = getLoggedInUserRole();
  return [ADMIN_ROLE.TITAN, ADMIN_ROLE.TITAN_SUPPORT].includes(role);
};

export const clearAuthSession = keysToSkip => {
  clearStorage(keysToSkip);
  store.dispatch("domain/resetState");
};

/**
 * this function stores login related info in smartStorage
 * @param {object} - login data
 */
export function storeLoginData(data) {
  const {
    token,
    partnerId,
    actor: { role, attrs = {}, id },
    bllUserId,
    primaryDomain,
    userEmail,
    expiryEpochTimestamp,
    adminType,
    isDomainAdmin,
    primaryBundle,
  } = data;

  Object.entries({
    authToken: token,
    partnerId,
    role,
    bllUserId,
    domain: primaryDomain,
    tempUserAltEmail: userEmail,
    altEmail: userEmail,
    authTokenExpiry: expiryEpochTimestamp,
    adminType,
    isDomainAdmin,
    userName: attrs.userName,
    accountId: id,
  }).forEach(([key, value]) => {
    value !== undefined && smartStorage.setItem(key, value);
  });
  if (primaryBundle?.id) {
    smartStorage.setItem("bundleId", primaryBundle.id);
  }
  store.dispatch("showDomainAdminPopup", isDomainAdmin);
  store.dispatch("domain/domainName", primaryDomain);
  store.dispatch("partnerId", partnerId);
}
